// Trix wants to be global
window.Trix = require("trix");
import "@rails/actiontext";
Trix.config.textAttributes.underline = {
  tagName: 'u',
  inheritable: true
};
Trix.config.textAttributes.alignLeft = {
  tagName: 'align-left',
  parse: false,
  nestable: false,
  exclusive: true
};
Trix.config.textAttributes.alignCenter = {
  tagName: 'align-center',
  parse: false,
  nestable: false,
  exclusive: true
};
Trix.config.textAttributes.alignRight = {
  tagName: 'align-right',
  parse: false,
  nestable: false,
  exclusive: true
};
Trix.config.textAttributes.alignJustify = {
  tagName: 'align-justify',
  parse: false,
  nestable: false,
  exclusive: true
};
/* insert the button visual in the default toolbar */

addEventListener("trix-initialize", function (event) {
  var underlineButtonHTML = '<button type="button" class="trix-button trix-button--icon trix-button--icon-underline" data-trix-attribute="underline" title="Underline">Underline</button>';
  event.target.toolbarElement.querySelectorAll(".trix-button-group button")[1].insertAdjacentHTML("afterend", underlineButtonHTML);
  var alignmentButtonsHTML = '<span class="trix-button-group trix-button-group--alignment-tools"><button type="button" class="trix-button trix-button--icon trix-button--icon-align-left" data-trix-attribute="alignLeft" title="Align Left" tabIndex="-1">Align Left</button><button type="button" class="trix-button trix-button--icon trix-button--icon-align-center" data-trix-attribute="alignCenter" title="Align Center" tabIndex="-1">Align Center</button><button type="button" class="trix-button trix-button--icon trix-button--icon-align-right" data-trix-attribute="alignRight" title="Align Right" tabIndex="-1">Align Right</button><button type="button" class="trix-button trix-button--icon trix-button--icon-align-justify" data-trix-attribute="alignJustify" title="Align Justify" tabIndex="-1">Align Justify</button></span>';
  event.target.toolbarElement.querySelectorAll(".trix-button-group.trix-button-group--block-tools")[0].insertAdjacentHTML("afterend", alignmentButtonsHTML);
});